import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import parse from "html-react-parser"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"
import MenuGroup from "aldoo-ra/MenuGroup"
import StatisticsCardsRating from "./StatisticsCardsRating"

const StartLearningSection = () => {
  return (
    <div className="flex flex-col w-full align-center bg-gradient_start_journey px-[30px] md:px-px1_l xl:px-px1_xl pt-[30px] md:pt-px1_xl lg:pt-[109px] pb-[60px] md:pb-[70px] lg:pb-[116px] rounded-[50px] md:rounded-[100px]">
      {/* White Container */}
      <CMSRender
        contentType="StartNowSection"
        renderItem={(data, id) => {
          return (
            <div
              key={id}
              className="flex flex-col w-full  lg:max-w-[1062px] xl:max-w-w2_xl items-center justify-center bg-paper rounded-[50px] md:rounded-[56px] lg:rounded-[70px] px-10 pt-px1_xl pb-px1_xl lg:pb-[93px] mb-10 lg:mb-[70px] mx-auto"
            >
              {/* Oxford Logo */}
              <div className="w-[110px] md:w-[120px] aspect-1/1 mb-[42px]">
                <img
                  src={data.image}
                  alt="Oxford Dictionary Logo"
                  className="w-full h-full"
                />
              </div>

              {/* Heading */}
              <Typography
                component="h2"
                variant="h1"
                className="md:w-[560px] lg:w-full text-text text-center mb-[32px]"
              >
                <div key={id}>{data.title && typeof data.title === 'string' ? parse(data.title) : data.title}</div>
              </Typography>

              {/* Subheading */}
              <Typography variant="body1" className="md:w-[560px] lg:w-full text-center mb-[45px]">
                {data.description}
              </Typography>

              {/* Download Buttons */}
              <div className="flex flex-col md:flex-row justify-center gap-[9px] lg:gap-[28px]">
                {/* {data.buttons &&
                  data.buttons.map((button, index) => (
                    <Button key={index} variant="platform_m_outlined">
                      <a 
                        // href={button.link.url} 
                        href="https://translate.aldoo.com/"
                        target="_blank"
                      >
                        <img
                          src={button.image}
                          alt={button.name}
                          className="w-[190px] h-[55px] object-cover"
                        />
                      </a>
                    </Button>
                  ))} */}

                {/* App Stores */}
                <div className="mt-10">
                  <MenuGroup 
                    name="MobileStoresBadges" 
                    renderAs="hlist.icons" 
                    menuItemRender={(item) => {
                      return <Button variant="platform_m_outlined">
                        <img
                        src={item.image}
                        alt={item.name}
                        className="w-[190px] h-[55px] object-cover"
                      />
                    
                    </Button>
                    }}
                  />
                </div>  
              </div>
            </div>
          )
        }}
      />
      <StatisticsCardsRating />
    </div>
  )
}

export default StartLearningSection
